"use client";

import { useState } from "react";
import type { Issue } from "../constants";
import { RoadmapGrid } from "./RoadmapGrid";
import { RoadmapList } from "./RoadmapList";
import { RoadmapViewControls } from "./RoadmapViewControls";

type SectionNames = {
	planned: string;
	inProgress: string;
	completed: string;
};

type StateMappings = {
	planned: string[];
	inProgress: string[];
	completed: string[];
};

export const RoadmapView = ({
	issues,
	sectionNames,
	stateMappings,
}: {
	issues: Issue[];
	sectionNames: SectionNames;
	stateMappings: StateMappings;
}) => {
	const [viewMode, setViewMode] = useState<"board" | "list">("board");
	const [searchQuery, setSearchQuery] = useState("");

	const filteredIssues = issues.filter((issue) =>
		issue.title.toLowerCase().includes(searchQuery.toLowerCase()),
	);

	return (
		<div className="mb-16 flex flex-col gap-4">
			<RoadmapViewControls
				initialView={viewMode}
				handleView={setViewMode}
				handleSearch={setSearchQuery}
			/>
			{viewMode === "board" ? (
				<RoadmapGrid
					issues={filteredIssues}
					sectionNames={sectionNames}
					stateMappings={stateMappings}
				/>
			) : (
				<RoadmapList issues={filteredIssues} stateMappings={stateMappings} />
			)}
		</div>
	);
};
